<template>
  <div class="pumpcontrol" :alert="minutesOnAlert>0">
      <div class="app-columns">
        <Sidebar current="pumpcontrol"></Sidebar>
        <div class="pumpview" :inactive="!challengeActive">
          <div class="pump-header">
            <div id="power-usage">
              <div class="value-label">Power Usage</div>
              <div class="value-number">{{powerUsage}} <span>kWh</span></div>
            </div>
            <div id="current-rates">
              <div class="value-label">Current Rates</div>
              <div class="value-number">${{currentRate.toFixed(2)}} <span>/kWh</span> <span :class="['value-tag',peakRate ? 'onpeak' : 'offpeak']">{{peakRate ? 'On-Peak' : 'Off-Peak'}}</span></div>
            </div>
            <div class="value-totals" id="total-power">
              <div>
                <div class="value-label">Total power Used</div>
                <div class="value-number">{{totalPower.toFixed(2)}} <span>kWh</span></div>
              </div>
              <div>
                <div class="value-label">Total Cost</div>
                <div class="value-number">${{totalCost.toFixed(2)}}</div>
              </div>
            </div>
          </div>
          <div class="pump-content">
            <div class="box-container water-tower">
              <div class="box-header" id="water-tower">Water Tower</div>
              <div class="box-content">
                <div class="left-container">
                  <div class="water-level-perc">
                    Water Level<br>
                    <span class='big-value'>{{currentLevel.toFixed(0)}}%</span>
                  </div>
                  <div id="increase-signal" class="water-level-gpm">
                    <span :class="['water-level-dir', currentIncrease <= 0 ? 'status-decrease' : 'status-increase', currentIncrease <= 0 ? 'border-decrease' : 'border-increase']"></span>
                    <span class='small-value'>{{currentIncrease}}</span>GPM
                  </div>
                  <div :class="['water-level-indicator', currentIncrease <= 0 ? 'status-decrease' : 'status-increase']">
                    <span v-if="currentIncrease<-100">Rapid Decrease</span>
                    <span v-if="currentIncrease<=0 && currentIncrease>=-100">Steady Decrease</span>
                    <span v-if="currentIncrease>0 && currentIncrease<=100">Steady Increase</span>
                    <span v-if="currentIncrease>100">Rapid Increase</span>
                  </div>
                </div>
                <div class="water-level-status" :levelstatus="levelStatus">
                  <div class="level-label">Water Level %</div>
                  <div class="level-steps">
                    <div level="100">100</div>
                    <div level="50">50</div>
                    <div level="0">0</div>
                  </div>
                  <div class="level-tower"><div class="level-current" :style="levelStyle"></div></div>
                  <div class="level-perc">
                    <div plevel="90"><span class="points">--------</span> <span class="perc-value"><span>90%</span><img src="@/assets/img/level_alert.svg" width="20"></span></div>
                    <div plevel="10"><span class="points">--------</span> <span class="perc-value"><span>10%</span><img src="@/assets/img/level_alert.svg" width="20"></span></div>
                  </div>
                </div>
                <div class="right-container">
                  <div class="water-level-supply">
                    Supply<br>
                    <span class='medium-value'>+{{currentSupply}}</span> GPM
                  </div>
                  <div class="water-level-demand">
                    Demand<br>
                    <span class='medium-value'>-{{currentDemand}}</span>GPM
                  </div>
                </div>
              </div>
            </div>
            <div class="water-connections">
              <div class="pump-up" :active="pumps[0].active||pumps[1].active||pumps[2].active"></div>
              <div class="pumps">
                <div class="pump-left" :active="pumps[0].active"></div>
                <div class="pump-center" :active="pumps[1].active"></div>
                <div class="pump-right" :active="pumps[2].active"></div>
              </div>
            </div>
            <div class="water-pumps" >
              <div class="box-container water-pump" :state="pump.state" v-for="pump in pumps" :key="pump.number" :id="'water-pump-'+pump.number" :broken="pump.repair>0" :stopped="pump.preventFail" :repairlevel="repairLevel(pump)" :askrepair="pump.askRepair" :askanalytics="pump.askAnalytics" :analytics="pump.analytics" >
                <div class="box-header">Pump <span>{{pump.number}}</span></div>
                <div class="box-content"  v-if="!pump.askRepair && !pump.askAnalytics">
                  <div class="box-container pump-state" >
                    <SmokeEffect v-if="repairLevel(pump)>0 && !pump.askRepair && !pump.analytics" :active="challengeActive" :level="repairLevel(pump)"></SmokeEffect>
                    <div class="box-header" :state="pumpState(pump)">{{pumpState(pump)}}</div>
                    <div class="box-content pump-box-state" :id="'pump-state-'+pump.number" v-if="!pump.askRepair">
                      <div class="pump-value"><span>{{(pump.power*pump.active).toFixed(1)}}</span> kWh</div>
                      <div class="pump-image" :active="pump.active">
                      </div>
                      <div class="pump-value"><span>{{pump.gpm*pump.active>=0?'+':''}}{{pump.gpm*pump.active}}</span> GPM</div>
                    </div>
                    <div class="pump-separator"></div>
                    <div class="pump-buttons">
                      <div :id="'analytics-pump-'+pump.number" @click="askAnalytics(pump)" :clickable="canActivateAnalytics(pump)" class="action-icon icon-analytics" :analytics="pump.analytics"></div>
                      <div class="action-switch" :id="'turn-on-pump-'+pump.number" :clickable="canActivate(pump)" :active="pump.active" @click="activate(pump)"><div class='switch-on'>On</div><div class="switch-icon"></div><div class='switch-off'>Off</div></div>
                      <div :id="'repair-pump-'+pump.number" @click="askForRepair(pump)" :clickable="canRepair(pump)" class="action-icon icon-repair"></div>
                    </div>
                  </div>
                  <div class="box-container pump-repair" >
                    Repairing
                    <br>
                    <div class="repair-progress"><div class="repair-progress-level" :style="{width:(pump.percent||0)+'%'}"></div></div>
                  </div>
                </div>
                <div class="box-content" v-if="pump.askRepair">
                  <div class="repair-message" v-if="isMajorRepair(pump)">
                    Major Pump Repairs
                    <br>
                    <b>${{pump.repairValue}}</b>
                  </div>
                  <div class="repair-message" v-if="!isMajorRepair(pump)">
                    Regular Pump Repairs
                    <br>
                    <b>${{pump.repairValue}}</b>
                  </div>
                  <div class="repair-buttons">
                    <div class="small-button" :id="'begin-repair-pump-'+pump.number" @click="doRepair(pump)">Begin Repair</div>
                    <div class="action-icon icon-close" :id="'repair-pump-'+pump.number" @click="cancelRepair(pump)"></div>
                  </div>
                </div>
                <div class="box-content" v-if="pump.askAnalytics">
                  <div class="repair-message" >
                    Pump Analytics
                    <br>
                    <b>${{analyticsValue}}</b>
                  </div>
                  <div class="repair-buttons">
                    <div class="small-button" @click="doAnalytics(pump)">Purchase</div>
                    <div class="action-icon icon-close" :id="'analytics-pump-'+pump.number" @click="cancelAnalytics(pump)"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="pump-debug" v-if="debug">{{debugInfo}}</div>
  </div>
</template>

<script>
import Sidebar from '@/views/app/Sidebar.vue'
import SmokeEffect from '@/components/SmokeEffect.vue'
import messages from '@/lib/messages.js'
import simulation from '@/lib/simulation.js'

export default {
  name: 'pumpcontrol',
  data: function () {
    return simulation.data
  },
  mounted: function () {
    let start = false
    if (simulation.challengeNumber !== this.challenge.number * 1) {
      simulation.challengeNumber = this.challenge.number * 1
      simulation.reset()
      start = true
    }
    this.restore()
    if (!simulation.data.tutorialId || start || !simulation.started) {
      this.startMonitor()
    }
  },
  methods: {
    clear: function () {
      simulation.clear()
    },
    reset: function () {
      simulation.clear()
    },
    restore: function () {
      simulation.restore()
    },
    save: function () {
      simulation.save()
    },
    stopMonitor: function () {
      simulation.stopMonitor()
    },
    startMonitor: function () {
      const self = this
      simulation.challengeNumber = this.challenge.number
      simulation.startMonitor(function () {
        self.monitor()
      })
    },
    activate: function (pump) {
      if (!this.canActivate(pump)) {
        return
      }
      pump.active = !pump.active
      if (pump.broken) {
        pump.state = 'Pump Failed'
      } else {
        pump.state = pump.active ? 'Running' : 'Stopped'
      }
      this.updateLevel()
    },
    canActivate: function (pump) {
      if (!this.challengeActive) {
        return false
      }
      const tutid = simulation.data.tutorialId
      if (tutid) {
        const sections = tutid.split('.')[0]
        const parts = sections.split('-')
        if ((parts[0] !== 'turn' && parts[0] !== 'stop') || parts[3] * 1 !== pump.number) {
          return false
        }
      }
      if (pump.repair > simulation.params.MAJOR_REPAIR_DAMAGE_LIMIT && !pump.active) {
        // return false
      }
      return true
    },
    canActivateAnalytics: function (pump) {
      const tutid = simulation.data.tutorialId
      if (tutid) {
        return tutid === 'ch2-tutorial' && pump.number === 1
      }
      return this.analyticsActive
    },
    canRepair: function (pump) {
      if (!this.challengeActive) {
        return false
      }
      const tutid = simulation.data.tutorialId
      if (tutid) {
        const parts = tutid.split('.')[0].split('-')
        if ((parts[0] !== 'repair' && parts[0] !== 'analytics') || parts[2] * 1 !== pump.number) {
          return false
        }
      }
      if (pump.repair >= simulation.params.MINOR_REPAIR_DAMAGE_LIMIT) {
        return true
      }
      return false
    },
    askForRepair: function (pump) {
      if (this.canRepair(pump)) {
        simulation.askPumpRepair(pump)
      }
    },
    isMajorRepair: function (pump) {
      return pump.repairValue > simulation.params.MINOR_REPAIR
    },
    askAnalytics: function (pump) {
      if (this.canActivateAnalytics(pump)) {
        simulation.askAnalytics(pump)
      }
    },
    cancelAnalytics: function (pump) {
      pump.askAnalytics = false
    },
    cancelRepair: function (pump) {
      pump.askRepair = false
    },
    doRepair: function (pump) {
      simulation.doRepair(pump)
    },
    doAnalytics: function (pump) {
      simulation.doAnalytics(pump)
    },
    animateValue: function (idx, value) {
      let changes = 0
      const self = this
      clearTimeout(this.timeouts[idx])
      if (typeof this[idx] !== 'undefined') {
        if (Math.abs(this[idx] - value) > 1) {
          changes++
          this[idx] = Math.round((this[idx] + value) / 2)
        } else {
          this[idx] = value
        }
      }
      if (changes > 0) {
        this.timeouts[idx] = setTimeout(function () {
          self.animateValue(idx, value)
        }, 100)
      }
    },
    updateLevel: function () {
      let supply = 0
      for (const idx in this.pumps) {
        if (this.pumps[idx].active) {
          supply += this.pumps[idx].gpm
        }
      }
      this.animateValue('currentSupply', supply)
    },
    monitor: function () {
      const minutesByTick = this.minutesByInterval
      const increase = minutesByTick * 60
      if (this.currentTime >= simulation.params.END_TIME || this.challengeFailed) {
        this.$emit('updatetime', this.currentTime)
        this.stopMonitor()
        return
      }
      for (const idx in this.pumps) {
        if (this.pumps[idx].repair > 0 && this.pumps[idx].state === 'Repair') {
          this.pumps[idx].lastRepair = this.currentTime
          this.pumps[idx].repair -= 10
          this.pumps[idx].percent = 100 - Math.round(this.pumps[idx].repair * 100 / this.pumps[idx].repairTotal)
          // console.log('repair', this.pumps[idx].repair, this.pumps[idx].repairTotal, this.pumps[idx].percent)
          if (this.pumps[idx].repair <= 0) {
            this.pumps[idx].gpm = simulation.params.FULL_REPAIR_GPM
            this.pumps[idx].repair = 0
            this.pumps[idx].damaged = false
            this.pumps[idx].broken = false
            this.pumps[idx].state = 'Stopped'
          }
        }
        if (this.pumps[idx].active && this.pumps[idx].gpm > 0 && this.pumps[idx].repair > 0) {
          this.pumps[idx].gpm -= Math.round(Math.random() * 10)
          this.pumps[idx].gpm = Math.max(0, this.pumps[idx].gpm)
        }
        if (this.pumps[idx].active && !this.pumps[idx].broken) {
          if (Math.random() < simulation.data.gpmDamageProbability && this.repairLevel(this.pumps[idx]) < 1) {
            this.pumps[idx].gpm += Math.round((Math.random() * 3) - 2)
            this.pumps[idx].gpm = Math.min(simulation.params.FULL_REPAIR_GPM, Math.max(0, this.pumps[idx].gpm))
          }
          if (this.pumps[idx].gpm <= this.randomPumpDamageGPM && Math.random() < this.randomPumpFailProbability) {
            this.pumps[idx].repair += 30
          }
          if (this.pumps[idx].gpm < simulation.params.GPM_LOW_DAMAGE) {
            if (simulation.challengeNumber > 0 || !simulation.data.tutorialId) {
              this.pumps[idx].repair += 5
            }
            if (this.pumps[idx].gpm < simulation.params.GPM_SMALL_DAMAGE) {
              this.pumps[idx].repair += 10
            }
            if (this.pumps[idx].gpm < simulation.params.GPM_MEDIUM_DAMAGE) {
              this.pumps[idx].repair += 20
            }
            if (this.pumps[idx].gpm < simulation.params.GPM_HIGH_DAMAGE) {
              this.pumps[idx].repair += 50
            }
            if ((this.pumps[idx].repair >= simulation.params.MAJOR_REPAIR || this.pumps[idx].gpm < simulation.params.GPM_HIGH_DAMAGE) && this.pumps[idx].state !== 'Repair') {
              // this.pumps[idx].state = 'Stopped'
              // this.pumps[idx].active = false
              this.pumpFail(idx, simulation.params.MAJOR_REPAIR)
            }
          }
          for (const idx1 in this.events) {
            const ev = this.events[idx1]
            if (ev.position - 1800 === this.currentTime) {
              ev.incoming = true
            }
            if (ev.position === this.currentTime) {
              if (!this.currentEvent || this.currentEvent.position !== this.currentTime) {
                this.currentEvent = ev
                ev.incoming = false
                if (ev.type === 'pump-damage') {
                  for (const idxp in this.pumps) {
                    const DAMAGE_GUARANTEED_HOURS = 0.5
                    const canDamage = simulation.challengeNumber === 0 || (this.pumps[idxp].active && (this.pumps[idxp].lastRepair + DAMAGE_GUARANTEED_HOURS * 3600) < this.currentTime)
                    if ((this.pumps[idxp].number === ev.pump || ev.pump === 0) && canDamage) {
                      this.pumpDamage(this.pumps[idxp], ev.repair)
                      this.lastPumpFailTimestamp = this.currentTime
                      break
                    }
                  }
                }
                if (ev.type === 'pump-break') {
                  for (const idxp in this.pumps) {
                    if ((this.pumps[idxp].number === ev.pump || ev.pump === 0)) {
                      if (this.pumpCanBreak(idxp) && (simulation.challengeNumber === 0 || this.failCounter > 5)) {
                        this.pumpFail(idxp, ev.repair, ev.message)
                        break
                      }
                    }
                  }
                }
                if (ev.type === 'demand') {
                  this.currentDemand = this.currentDemand + ev.value
                }
                if (ev.type === 'rate') {
                  this.currentRate = ev.value
                }
              }
            }
          }
        } else {
          let maxgpm = simulation.params.FULL_REPAIR_GPM
          if (this.pumps[idx].repair > 0) {
            maxgpm = maxgpm - 20
          }
          if (this.pumps[idx].repair < simulation.params.MAX_WORKING_REPAIR_LEVEL) {
            this.pumps[idx].gpm = Math.min(maxgpm, this.pumps[idx].gpm + 1)
          }
        }
      }
      const pumpFailTime = this.currentTime > 3600 * this.randomFailAfterHours && (this.currentTime - this.randomPumpFailTime) > 3600 * this.randomFailIntervalHours
      const rnd = Math.random()
      const randomFail = rnd < this.randomPumpFailProbability && pumpFailTime && this.randomPumpFails < this.maxRandomPumpFails && this.pumpIncidents < simulation.params.MAX_PUMP_INCIDENTS
      const pumpIdx = this.nextRandomPump()
      // console.log('fail', pumpIdx, randomFail)
      if (randomFail && pumpIdx >= 0 && this.pumpCanBreak(pumpIdx, true)) {
        this.pumpFail(pumpIdx, 501, 'Pump {pump.number} failed unexpectedly. You should repair this pump.')
        this.randomPumpFails++
        this.randomPumpFailTime = this.currentTime
      }
      const pumpIdxDmg = this.nextRandomPump(true)
      if (this.failCounter > this.minEventTimeSeconds && this.challenge.number > 0 && pumpIdxDmg >= 0) {
        this.pumpDamage(this.pumps[pumpIdxDmg], this.pumpDamageRepairLevel)
        this.lastPumpFailTimestamp = this.currentTime
      }
      this.updateLevel()
      const demandChange = Math.round((Math.random() * 6) - 3)
      this.currentDemand = Math.min(720, this.currentDemand)
      this.animateValue('currentDemand', this.currentDemand + demandChange)
      const diff = this.currentSupply - this.currentDemand
      this.currentLevel += (diff / 100)
      this.currentLevel = Math.max(0, Math.min(100, this.currentLevel))
      if (this.currentLevel < 10 || this.currentLevel > 90) {
        if (this.minutesOnWarning <= 0) {
          this.newIssue = true
        }
        this.minutesOnWarning += minutesByTick
        if (this.minutesOnWarning > 5 && this.newIssue) {
          this.townIssues++
          this.newIssue = false
        }
      } else {
        this.minutesOnWarning = Math.max(0, Math.min(60, this.minutesOnWarning - 3))
      }
      if (this.currentLevel === 0 || this.currentLevel === 100) {
        this.minutesOnAlert += minutesByTick
      } else {
        this.minutesOnAlert = Math.max(0, Math.min(29, this.minutesOnAlert - 3))
        if (this.minutesOnAlert <= 0) {
          this.newAlert = true
        }
      }
      if (this.minutesOnAlert > 30 && this.newAlert) {
        this.townIncidents++
        this.newAlert = false
      }
      if (this.minutesOnAlert === 0) {
        if (this.minutesOnWarning > 5) {
          this.customerSatisfaction += 8
        } else {
          this.customerSatisfaction += 10
        }
      } else if (this.minutesOnAlert > Math.min(this.towerOverflowTimeout, this.towerEmptyTimeout)) {
        if (this.currentLevel === 100 && simulation.challengeNumber > 0 && this.minutesOnAlert > this.towerOverflowTimeout) {
          this.customerSatisfaction = 0
          this.challengeFailed = true
          this.towerOverflow = true
        }
        if (this.currentLevel === 0 && simulation.challengeNumber > 0 && this.minutesOnAlert > this.towerEmptyTimeout) {
          this.customerSatisfaction = 0
          this.challengeFailed = true
        }
      } else if (this.minutesOnAlert > 45) {
        this.customerSatisfaction += 2
      } else if (this.minutesOnAlert > 30) {
        this.customerSatisfaction += 5
      } else {
        this.customerSatisfaction += 7
      }
      this.customerSatisfactionExpected += 10
      const factor = increase / 3600
      this.totalPower += this.powerUsage * factor
      this.totalCost += this.currentRate * this.powerUsage * factor
      this.totalPowerCost += this.currentRate * this.powerUsage * factor
      this.currentTime += increase
      this.currentTime = Math.min(this.currentTime, simulation.params.END_TIME)
      this.$emit('updatetime', this.currentTime)
      const count = messages.deliverMessages(this.currentTime)
      if (count) {
        this.$emit('newmessages', count)
      }
      if (this.pumpIncidents > simulation.params.MAX_PUMP_INCIDENTS && simulation.challengeNumber > 0) {
        this.challengeFailed = true
      }
      this.save()
    },
    nextRandomPump: function (damage) {
      const sel = []
      for (const idx in this.pumps) {
        const pump = this.pumps[idx]
        if (pump.state === 'Repair') {
          continue
        }
        if (this.pumpCanBreak(idx, true, damage)) {
          sel.push(idx)
          if (pump.analytics) {
            sel.push(idx)
            sel.push(idx)
          }
          if (this.repairLevel(pump) === 1) {
            sel.push(idx)
          }
        }
        if (this.repairLevel(pump) === 2) {
          return -1
        }
      }
      if (sel.length === 0) {
        return -1
      }
      const selIdx = Math.floor(Math.random() * sel.length)
      return sel[selIdx]
    },
    pumpState: function (pump) {
      let state = pump.state
      if (pump.broken) {
        state = 'Pump Failed'
      }
      if (pump.analytics && pump.preventFail) {
        state = 'Repair Pump'
      }
      return state
    },
    repairLevel: function (pump) {
      if (pump.repair >= simulation.params.MAJOR_REPAIR_DAMAGE_LIMIT) {
        return 2
      } if (pump.repair >= simulation.params.MAX_WORKING_REPAIR_LEVEL) {
        return 1
      } else if (pump.repair >= simulation.params.SMOKE_DAMAGE_LIMIT) {
        return 1
      } else if (pump.damaged) {
        return 1
      } else {
        return 0
      }
    },
    pumpMessage: function (subject, message) {
      if (simulation.challengeNumber * 1 === 0) {
        return
      }
      let content = []
      if (message) {
        content = [message]
      }
      const msg = {
        id: simulation.data.currentTime,
        from: 'Maintenance Manager',
        icon: 'icon-pumpengineer',
        subject: subject,
        read: false,
        content: content,
        time: simulation.data.currentTime + 120,
        buttons: [
        ]
      }
      messages.deliverMessage(msg)
    },
    pumpBreakMessage: function (pump) {
      this.pumpMessage('You should repair Pump ' + pump.number)
    },
    analyticsMessage: function (pump, value) {
      this.pumpMessage('Pump ' + pump.number + ' Stopped', 'Analytics saved us $400, good decision!')
    },
    pumpCanBreak: function (idx, randomBreak, onlyDamage) {
      if (this.currentTime > 3600 * 23) {
        return false
      }
      const expiredWarranty = (this.pumps[idx].lastRepair + simulation.params.REPAIR_GUARANTEED_HOURS * 3600) < this.currentTime
      const isTutorial = (simulation.challengeNumber === 0)
      const needsRepair = this.pumps[idx].repair > 0 || (randomBreak && this.pumps[idx].gpm <= this.randomPumpFailGPM && this.failCounter > 6) || onlyDamage
      const alreadyBroken = this.pumps[idx].broken || this.pumps[idx].state === 'Repair'
      const lastFailed = this.previousFailedPump === idx
      return isTutorial || (this.pumps[idx].active && needsRepair && expiredWarranty && !alreadyBroken && !lastFailed)
    },
    pumpDamage: function (pump, repair) {
      pump.repair = Math.max(repair, pump.repair)
      pump.damaged = true
      pump.gpm = Math.min(simulation.params.GPM_LOW_DAMAGE, pump.gpm)
    },
    pumpFail: function (idx, repair, message) {
      if (repair) {
        this.pumps[idx].repair = repair
      }
      if (this.pumps[idx].repair >= simulation.params.MAJOR_REPAIR_DAMAGE_LIMIT && this.pumps[idx].state !== 'Repair') {
        this.lastPumpFailTimestamp = this.currentTime
        this.randomPumpFailTime = Math.max(this.currentTime - 3600 * 2, this.randomPumpFailTime)
        this.previousFailedPump = idx
        if (this.pumps[idx].analytics) {
          this.pumpIncidentsAvoided++
          this.analyticsSaves += simulation.params.MAJOR_REPAIR
          this.pumps[idx].repair = simulation.params.MAX_WORKING_REPAIR_LEVEL + 1
          this.pumps[idx].state = 'Stopped'
          this.pumps[idx].active = false
          this.pumps[idx].preventFail = true
          this.analyticsMessage(this.pumps[idx], simulation.params.MAJOR_REPAIR)
          this.$emit('pumpFailed', this.pumps[idx])
        } else {
          this.pumps[idx].gpm = 0
          this.pumps[idx].broken = true
          this.pumps[idx].preventFail = false
          this.pumps[idx].askRepair = false
          this.pumps[idx].askAnalytics = false
          this.pumpIncidents++
          let msg = 'You should repair Pump ' + this.pumps[idx].number
          if (message) {
            msg = message.replace('{pump.number}', this.pumps[idx].number)
          }
          this.pumpMessage(msg)
          this.$emit('pumpFailed', this.pumps[idx])
        }
      }
    }
  },
  components: {
    Sidebar,
    SmokeEffect
  },
  computed: {
    debugInfo: function () {
      const info = {
        failCounter: this.failCounter,
        randomCounter: ((this.currentTime - this.randomPumpFailTime) / 3600).toFixed(2),
        customerSatisfaction: this.customerSatisfaction + '/' + this.customerSatisfactionExpected,
        pumps: this.pumps
      }
      return JSON.stringify(info, null, ' ')
    },
    levelStatus: function () {
      let status = 0
      const lvl = Math.round(this.currentLevel)
      if (lvl === 100) {
        status = 2
      } else if (lvl >= 90) {
        status = 1
      } else if (lvl === 0) {
        status = -2
      } else if (lvl <= 10) {
        status = -1
      }
      return status
    },
    failCounter: function () {
      return (this.currentTime - this.lastPumpFailTimestamp) / 1000
    },
    levelStyle: function () {
      return {
        height: this.currentLevel.toFixed(0) + '%'
      }
    },
    powerUsage: function () {
      let level = 0
      for (const idx in this.pumps) {
        level += this.pumps[idx].power * this.pumps[idx].active
      }
      return '' + level.toFixed(1)
    },
    currentIncrease: function () {
      if (this.currentLevel <= 0) {
        return 0
      }
      const increase = (this.currentSupply - this.currentDemand)
      return (increase >= 0 ? '+' : '') + increase
    },
    challengeActive: function () {
      return this.currentTime < simulation.params.END_TIME && simulation.running
    },
    peakRate: function () {
      return this.currentRate === simulation.params.PEAK_RATE
    },
    analyticsValue: function () {
      return simulation.params.ANALYTICS_VALUE
    },
    analyticsActive: function () {
      return simulation.challengeNumber > 1 && !simulation.data.tutorialId
    }
  },
  props: {
    challenge: Object
  },
  watch: {
    challenge: function (newValue) {
    }
  }
}
</script>

<style scoped lang="scss">
.pumpcontrol{
  background-color: #fff;
}
.pump-debug{
  position: fixed;
  background-color: rgba(0,0,0,0.2);
  color: #fff;
  font-size: 9px;
  left: 10px;
  bottom: 10px;
  min-width: 120px;
  white-space: pre-wrap;
  text-align: left;
  font-family: 'Courier New', Courier, monospace !important;
}
.pumpview{
  flex: 1;
  display: flex;
  flex-direction: column;
  &[inactive='true']{
    opacity: 0.7;
    pointer-events: none;
    * {
      cursor: default !important;
    }
  }
  .pump-repair{
    display: none;
  }
  .pump-header{
    height: 60px;
    display: flex;
    justify-content: space-between;
    text-align: left;
    align-items: center;
    padding: 12px 40px 8px 40px;
    > div{
      margin: 0 12px;
    }
    .value-totals{
      background-color: #F0F4F7;
      border-radius: 5px;
      display: flex;
      padding: 4px 16px;
      > div:first-child{
        margin-right: 20px;
      }
    }
    .value-label{
      font-size: 12px;
      text-transform: uppercase;
      color: #8F9297;
      white-space: nowrap;
    }
    .value-number{
      font-weight: bold;
      line-height: 1.3em;
      white-space: nowrap;
      font-size: 20px;
      > span{
        font-weight: normal;
        font-size: 12px;
      }
    }
    .value-tag{
      background-color: #ccc;
      color: #fff;
      border-radius: 3px;
      font-weight: bold !important;
      padding: 4px 8px;
      border-radius: 2px;
      transition: .3s;
      font-size: 12px;
      text-transform: uppercase;
      &.onpeak{
        background-color: #FF0000;
      }
      &.offpeak{
        background-color: #6BAF06;
      }
    }
  }
  .pump-content{
    flex: 1;
    background-color: #F1F9FF;
    .box-container{
      margin: 0 auto;
      background-color: #fff;
      border-radius: 5px;
      box-shadow: 0px 3px 6px #0000001A;
      .box-header{
        color: #fff;
        border-radius: 5px 5px 0 0;
        background-color: #0259B7;
        font-size: 14px;
        text-transform: uppercase;
        line-height: 2em;
        font-weight: bold;
        > span{
          width: 20px;
          height: 20px;
          display: inline-flex;
          justify-content: center;
          align-items: center;
          color: #0259B7;
          background-color: #fff;
          border-radius: 99% 99%;
          margin-left: 2px;
        }
      }
      .box-content{
        display: flex;
        justify-content: center;
        align-items: center;
        border: 4px solid transparent;
        border-top: 0px;
        > div{
          margin: 20px 20px;
          font-size: 12px;
          text-transform: uppercase;
        }
        .water-level-perc{
          width: 130px;
          background-color: #F3F3F3;
          border-radius: 5px 5px 0px 0px;
          padding: 20px;
          text-align: left;
          margin-bottom: 3px;
        }
        .water-level-gpm{
          width: 130px;
          background-color: #F3F3F3;
          padding: 20px;
          margin-bottom: 3px;
          line-height: 20px;
        }
        .water-level-dir{
          border: 1px solid #666;
          background-color: #888;
          display: inline-block;
          width: 20px;
          height: 20px;
          margin-bottom: -4px;
          border-radius: 2px;
          margin-right: 4px;
          background-repeat: no-repeat;
          background-size: 16px 16px;
          background-position: center;
          transition: transform linear .3s;
          background-image: url('../assets/img/arrow-down-white.svg');
          &.status-decrease{
          }
          &.status-increase{
            transform: rotate(180deg);
          }
        }
        .water-level-indicator{
          width: 130px;
          background-color: #888;
          color: #fff;
          border-radius: 0 0 5px 5px;
          text-transform: uppercase;
          padding: 6px 10px;
          font-size: 12px;
        }
        .water-level-supply{
          width: 120px;
          background-color: #F3F3F3;
          padding: 20px;
          margin-bottom: 3px;
          text-align: left;
        }
        .water-level-demand{
          width: 120px;
          background-color: #F3F3F3;
          padding: 20px;
          text-align: left;
        }
        .water-level-status{
          width: 130px;
          height: 160px;
          margin: 0 12px 0 0;
          display: flex;
          position: relative;
          padding-left: 20px;
          .level-tower{
            width: 25px;
            margin: 0 10px;
            background-color: #F3F3F3;
            position: relative;
            > .level-current{
              background-color: #025BBF;
              left: 0;
              bottom: 0;
              position: absolute;
              width: 100%;
              transition: height linear .3s;
            }
          }
          .level-label{
            text-transform: uppercase;
            -webkit-transform: rotate(-90deg);
            transform: rotate(-90deg);
            transform-origin: 0% 0% 0;
            width: 140px;
            position: absolute;
            text-align: center;
            bottom: 0;
            left: 0;
            font-size: 14px;
            color: #8F9297;
          }
          .level-steps{
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            font-weight: bold;
            font-size: 14px;
            position: relative;
            margin-right: 5px;
            > div::after{
              visibility: hidden;
              display: block;
              position: absolute;
              background-color: #f00;
              left: 100%;
              margin-left: 2px;
              width: 15px;
              height: 2px;
              content: " ";
            }
            > div[level='0']{
              margin-bottom: -0.5em;
            }
            > div[level='100']{
              margin-top: -0.5em;
            }
            > div[level='0']:after{
              bottom: 0;
            }
            > div[level='100']:after{
              top: 0;
            }
          }
          .level-perc{
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            padding: 0;
            font-weight: bold;
            white-space: nowrap;
            margin-left: -35px;
            z-index: 1;
            > div{
              line-height: 22px;
              width: 60px;
            }
            > span{
              display: inline-block;
            }
            .points{
              color: #ACACAC;
              display: inline-block;
            }
            .perc-value{
              padding: 0px 2px 0px 1px;
              color: #1E2F46;
              font-size: 16px;
              height: 22px;
              display: inline-block;
              position: relative;
              > img{
                display: inline-block;
                z-index: 2;
                position: relative;
              }
              > span {
                border-radius: 0 3px 3px 0;
                position: absolute;
                left: 20px;
                background-color: #F3F3F3;
                padding: 1px 3px 1px 10px;
                display: inline-block;
                line-height:1em;
                margin-left: -8px;
                z-index: 1;
              }
            }
            div[plevel='90']{
              padding-top: 4px;
              .points{
                vertical-align:top;
              }
            }
            div[plevel='10']{
              padding-bottom: 2px;
              .points{
                vertical-align:top;
              }
            }
          }
          &[levelstatus='1'], &[levelstatus='2'],&[levelstatus='-2'], &[levelstatus='-1']{
            .level-tower > .level-current{
              background-color: #FF0000;
              min-height: 2px;
            }
          }
          &[levelstatus='-2'],&[levelstatus='-1']{
            .level-perc div[plevel='10'] .perc-value > span{
              background-color: #FF0000;
              color: #fff;
            }
            div[plevel='10']{
              .points{
                color: #DC0000;
              }
            }
          }
          &[levelstatus='2'],&[levelstatus='1']{
            .level-perc div[plevel='90'] .perc-value > span{
              background-color: #FF0000;
              color: #fff;
            }
            div[plevel='90']{
              .points{
                color: #DC0000;
              }
            }
          }
          &[levelstatus='-2']{
            .level-steps{
              > div[level='0']{
                color: #DC0000;
              }
              > div[level='0']:after{
                visibility: visible;
              }
            }
          }
          &[levelstatus='2']{
            .level-tower > .level-current{
              min-height: 100%;
            }
            .level-steps{
              > div[level='100']{
                color: #DC0000;
              }
              > div[level='100']:after{
                visibility: visible;
              }
            }
          }
        }
        *[state='Stopped']{
          background-color: #F1C40F;
          background-image: url(../assets/img/stop-yellow.svg);
          background-repeat: no-repeat;
          background-position: 10% center;
          background-size: 18px 18px;
        }
        *[state='Pump Failed']{
          background-color: #D30000;
          background-image: url(../assets/img/alert-red.svg);
          background-repeat: no-repeat;
          background-position: 10% center;
          background-size: 18px 18px;
        }
        *[state='Repair Pump']{
          background-color: #F1C40F;
          background-image: url(../assets/img/repair-yellow.svg);
          background-repeat: no-repeat;
          background-position: 10% center;
          background-size: 18px 18px;
        }
        *[state='Running']{
          background-color: #6BAF06;
          background-image: url(../assets/img/checkmark-green.svg);
          background-repeat: no-repeat;
          background-position: 10% center;
        }
        .status-increase{
          background-color: #6BAF06
        }
        .border-increase{
          border: 1px solid #538803;
        }
        .status-decrease{
          background-color: #FF0000
        }
        .border-decrease{
          border: 1px solid #DC0000;
        }
        .big-value{
          font-size: 24px;
          font-weight: bold;
        }
        .medium-value{
          font-size: 20px;
          font-weight: bold;
        }
        .small-value{
          font-size: 16px;
          font-weight: bold;
        }
      }
      &[repairlevel='2']{
         > .box-header{
          background-color: #FF0000;
          span {
            color: #FF0000
          }
        }
        > .box-content{
          border-left: 4px solid #FF0000;
          border-right: 4px solid #FF0000;
          border-bottom: 4px solid #FF0000;
          border-radius: 0 0 5px 5px;
          box-sizing: border-box;
          > .pump-state {
            height: 122px;
          }
        }
      }
      &[analytics=true][stopped='true']{
        > .box-header{
          background-color: #6AAE05;
          span {
            color: #6AAE05
          }
        }
        > .box-content{
          border-left: 4px solid #6AAE05;
          border-right: 4px solid #6AAE05;
          border-bottom: 4px solid #6AAE05;
          border-radius: 0 0 5px 5px;
          box-sizing: border-box;
          > .pump-state {
            height: 126px;
          }
        }
      }
      &[askanalytics='true']{
        .box-header{
          background-color: #6AAE05;
          span {
            color: #6AAE05
          }
        }
        .box-content{
          border: 3px solid #6AAE05;
          border-top: 0px;
          border-radius: 0 0 5px 5px;
          height: 142px;
          flex-direction: column;
          justify-content: space-between;
        }
      }
      &[state='Repair']{
        .box-header{
          background-color: #FFCC01;
          span {
            color: #FFCC01
          }
        }
        .box-content{
          border: 3px solid #FFCC01;
          border-top: 0px;
          border-radius: 0 0 5px 5px;
          height: 142px;
          flex-direction: column;
          justify-content: space-between;
          .pump-state{
            display: none;
          }
          .pump-repair{
            display: block;
            text-transform: none;
            box-shadow: none;
            padding-top: 25%;
          }
        }
      }
      &[askrepair='true']{
        .box-header{
          background-color: #FF0000;
          span {
            color: #FF0000
          }
        }
        .box-content{
          border: 3px solid #FF0000;
          border-top: 0px;
          border-radius: 0 0 5px 5px;
          height: 142px;
          flex-direction: column;
          justify-content: space-between;
        }
      }
      .repair-message{
        height: 90px;
        background-color: #fff;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        margin: 0 !important;
        width: 100%;
        text-transform: none !important;
        font-size: 14px !important;
        line-height: 1.6em;
        b{
          font-size: 16px;
        }
      }
      .repair-buttons{
        border-top: 2px solid #eee;
        padding: 6px;
        margin: 0px !important;
        width: 90%;
        height: 44px;
        display: flex;
        justify-content: space-between;
      }
      .small-button{
        cursor: pointer;
        background-color: #00B5E2;
        color: #fff;
        border-radius: 15px;
        height: 30px;
        line-height: 30px;
        padding: 0 8px;
        display: inline-block;
        font-weight: bold;
        transition: background-color 0.2s;
        &:hover{
          background-color: #005EB8;
        }
      }
    }
    .water-tower{
      width: 550px;
      min-height: 230px;
      margin-top: 20px;
    }
    .water-pumps{
      display: flex;
      justify-content: center;
    }
    .water-pump{
      width: 26%;
      min-height: 170px;
      margin: 0 9px;
    }
    .action-icon{
      width: 26px;
      height: 26px;
      border-radius: 13px 13px;
      background-color: #E2E2E2;
      border: 2px solid #D2D2D2;
      background-repeat: no-repeat;
      background-size: 16px 16px;
      background-position: center;
      opacity: 0.3;
      transition: background-color 0.2s;
      &[clickable='true']{
        opacity: 1;
        cursor: pointer;
        &:hover.icon-repair{
          background-color: #ffffff;
          background-image: url('../assets/img/repair-hover.svg');
        }
        &:not([analytics='true']):hover.icon-analytics{
          background-color: #ffffff;
          background-image: url('../assets/img/analytics-hover.svg');
        }
      }
    }
    .icon-analytics{
      background-image: url('../assets/img/analytics.svg');
      &[analytics=true]{
        background-color: #6AAE05;
        background-image: url('../assets/img/analytics-white.svg');
        border: 2px solid #5C9705;
        opacity: 1 !important;
      }
    }
    .icon-repair{
      background-image: url('../assets/img/repair.svg');
    }
    .icon-close{
      cursor: pointer;
      width: 30px;
      height: 30px;
      border-radius: 15px 15px;
      background-color: #FFF;
      border: 1px solid #DCEFFF;
      background-image: url('../assets/img/close-blue.svg');
      background-size: 12px 12px;
      opacity: 1;
      &:hover{
        background-image: url('../assets/img/close-blue-hover.svg');
      }
    }
    .pump-state{
      max-width: 95%;
      width: 150px;
      background-color: #F3F3F3;
      position: relative;
      margin: 10px 0 3px 0 !important;
      box-shadow: none;
      .box-header{
        font-size: 12px;
        position: relative;
        padding-left: 8%;
      }
      .box-content{
        z-index: 1;
        position: relative;
        > div{
          margin: 0 4px;
          span{
            font-weight: bold;
          }
        }
      }
      .pump-box-state{
        z-index: 2;
        position: relative;
      }
      .pump-value{
        flex: 1;
      }
      .repair-state {
        margin: 0;
      }
      .pump-image{
        position: relative;
        width: 60px;
        flex: 1 0 60px;
        height: 50px;
        background-image: url(../assets/img/pump-inactive.svg);
        background-size: 60px 50px;
        background-position: center center;
        &[active='true']{
          background-image: url(../assets/img/pump.svg);
        }
      }
      .pump-separator{
        background-color: #fff;
        height: 8px;
        overflow:hidden;
      }
      .pump-buttons{
        margin-top: 0;
        border-top: 1px solid #E2E2E2;
        background-color: #fff;
        display: flex;
        justify-content: center;
        padding-top: 6px;
        margin-left: -5px;
        margin-right: -5px;
        .action-switch{
          display: flex;
          justify-content: space-between;
          line-height: 25px;
          padding: 0 10px;
          width: 70px;
          height: 26px;
          border-radius: 13px 13px;
          background-color: #E2E2E2;
          border: 1px solid #D2D2D2;
          position:relative;
          transition: background-color linear .3s;
          font-weight: bold;
          cursor: default;
          margin: 0 8px;
          opacity: 0.5;
          transtion: background-color 0.2s, color 0.2s, border-color 0.2s;
          &[clickable='true']{
            cursor: pointer;
            opacity: 1;
          }
          &[clickable='true']:hover{
            border-color: #B5B5B5;
          }
          .switch-icon{
            width: 19px;
            height: 19px;
            position: absolute;
            left: 3px;
            top:2px;
            transition: left linear .3s;
            border-radius: 10px 10px;
            background-color: #fff;
          }
          .switch-off{
            font-size: 12px;
            color: #444;
          }
          &[clickable='true']:hover .switch-off{
            color: #005EB8;
          }
          .switch-on{
            font-size: 12px;
            color: #E2E2E2;
          }
          &[active='true']{
            background-color: #00B5E2;
            border: 1px solid #009AC1;
            &[clickable='true']:hover{
              background-color: #005EB8;
              border-color: #00519F;
            }
            .switch-icon{
              left: 43px;
            }
            .switch-on{
              color: #fff;
            }
            .switch-off{
              display: none;
            }
          }
        }
      }
    }
    .water-connections{
      .pump-up, .pump-left, .pump-center, .pump-right{
        transition: linear .8s;
      }
      .pump-up{
        width:0px;
        height: 24px;
        margin: auto;
        border-left-width: 4px;
        border-left-style: dashed;
        border-left-color:#ACACAC;
        &[active='true']{
          border-left-style: solid;
          border-left-color:#00346D;
        }
      }
      .pumps{
        display: flex;
        justify-content: center;
        .pump-center{
          width:0px;
          height: 30px;
          border-left-width: 4px;
          border-left-style: dashed;
          border-left-color:#ACACAC;
          &[active='true']{
            border-left-style: solid;
            border-left-color:#00346D;
          }
        }
        .pump-left{
          width:185px;
          height: 30px;
          border-radius: 7px 0 0 0;
          border-top-width: 4px;
          border-top-style: dashed;
          border-top-color:#ACACAC;
          border-left-width: 4px;
          border-left-style: dashed;
          border-left-color:#ACACAC;
          &[active='true']{
            border-top-style: solid;
            border-top-color:#00346D;
            border-left-style: solid;
            border-left-color:#00346D;
          }
        }
        .pump-right{
          width:185px;
          height: 30px;
          border-top-width: 4px;
          border-top-style: dashed;
          border-top-color:#ACACAC;
          border-right-width: 4px;
          border-right-style: dashed;
          border-right-color:#ACACAC;
          &[active='true']{
            border-top-style: solid;
            border-top-color:#00346D;
            border-right-style: solid;
            border-right-color:#00346D;
          }
          border-radius: 0 7px 0 0;
        }
      }
    }
    .water-pumps{
      display: flex;
    }
  }
}
.repair-progress{
  background-color: #ddd;
  width: 120px;
  height: 14px;
  margin: 20px 0;
  padding: 0;
  border-radius: 7px;
  overflow: hidden;
  .repair-progress-level{
    background-color: #00D81D;
    height: 100%;
  }
}
.pumpcontrol[alert='true']{
  .water-level-perc span{
    color: #c00 !important;
  }
}
@media (max-height: 1040px) and (min-height: 880px){
  .challenge[number="0"] .pumpview{
    width: 440px;
  }
  .challenge[number="0"] .pumpview .pump-header{
    padding: 0;
    margin: 0 8px;
  }
  .challenge[number="0"] .pumpview .pump-content .water-tower{
    width: 95%;
  }
  .challenge[number="0"] .pumpview .pump-content .water-connections .pump-up{
    height: 2vh;
  }
  .challenge[number="0"] .pumpview .pump-content .water-connections .pumps > div {
    height: 2vh !important;
  }
  .challenge[number="0"] .pumpview .pump-content .pump-state .pump-buttons{
    margin-left: -3px;
    margin-right: -3px;
  }
  .challenge[number="0"] .pumpview .pump-content .pump-state .pump-image{
    width: 48px;
    height: 40px;
    flex: 1 0 48px;
    background-size: 48px 40px;
  }
  .challenge[number="0"] .pumpview .pump-content .water-pump{
    min-height: 150px;
    width: 28%;
  }
  .challenge[number="0"] .pumpview .pump-header .value-label{
    font-size: 12px;
  }
  .challenge[number="0"] .pumpview .pump-content .box-container[askrepair=true] .box-content{
    height: 135px;
  }
  .challenge[number="0"] .pumpview .pump-content .box-container[askanalytics=true] .box-content{
    height: 135px;
  }
  .challenge[number="0"] .pumpview .pump-content .box-container[state=Repair] .box-content{
    height: 135px;
  }
  .challenge[number="0"] .pumpview .pump-content .box-container[analytics=true][broken='true'] > .box-content > .pump-state{
    height: 118px;
  }
  .challenge[number="0"] .pumpview .pump-content .box-container[repairlevel="2"] > .box-content > .pump-state{
    height: 118px;
  }
}
@media (max-height: 880px){
  .pumpview{
    width: 440px;
  }
  .pumpview .pump-header{
    padding: 0;
    margin: 0 8px;
  }
  .pumpview .pump-content .water-tower{
    width: 95%;
  }
  .pumpview .pump-content .water-connections .pump-up{
    height: 2vh;
  }
  .pumpview .pump-content .water-connections .pumps > div {
    height: 2vh !important;
  }
  .pumpview .pump-content .box-container .box-content > div{
    margin: 4px;
  }
  .pumpview .pump-content .pump-state .pump-buttons{
    margin-left: -3px;
    margin-right: -3px;
  }
  .pumpview .pump-content .pump-state .pump-image{
    width: 48px;
    height: 40px;
    flex: 1 0 48px;
    background-size: 48px 40px;
  }
  .pumpview .pump-content .water-pump{
    min-height: 150px;
    width: 28%;
  }
  .pumpview .pump-header .value-label{
    font-size: 12px;
  }
  .pumpview .pump-content .box-container[askrepair=true] .box-content{
    height: 135px;
  }
  .pumpview .pump-content .box-container[askanalytics=true] .box-content{
    height: 135px;
  }
  .pumpview .pump-content .box-container[state=Repair] .box-content{
    height: 135px;
  }
  .pumpview .pump-content .box-container[analytics=true][broken='true'] > .box-content > .pump-state{
    height: 118px;
  }
  .pumpview .pump-content .box-container[repairlevel="2"] > .box-content > .pump-state{
    height: 118px;
  }
}
@media (max-height: 840px) {
  .pumpview .pump-content .water-tower{
    min-height: 180px;
    margin: 6px 12px 0 12px;
  }
  .pumpview .pump-header{
    height: 50px;
    .value-label{
      font-size: 10px;
    }
    .value-number{
      font-size: 16px;
    }
  }
  .pumpview .pump-content .water-pump{
    min-height: 150px;
    width: 30%;
    margin: 0 4px;
  }
  .pumpview .pump-content .pump-state{
    width: 90%;
  }
  .pumpview .pump-content .box-container .box-content {
    > .left-container > div, > .right-container > div  {
      padding: 10px 20px;
    }
    .water-level-status .level-perc div[plevel="10"]{
      padding-bottom: 1px;
    }
    .water-level-status .level-perc div[plevel="90"]{
      padding-top: 3px;
    }
    .water-level-indicator{
      padding: 6px !important;
    }
    .big-value, .medium-value{
      font-size: 18px;
    }
    .water-level-status{
      margin: 12px 8px;
      height: 140px;
      .level-label{
        width: 110px;
      }
      .level-tower{
        width: 20px;
      }
      .level-perc{
        > div{
          width: 50px;
        }
        span.points{
          font-size: 12px;
          margin-left: 4px;
          width: 25px;
        }
        .perc-value{
          font-size: 12px;
          span{
            margin-top: 2px;
          }
          > img {
            width: 18px;
            height: 18px;
          }
        }
      }
    }
  }
}
@media (max-height: 700px){
  .pumpview .pump-content .box-container .box-content .water-level-status{
    height: 120px;
  }
  .pumpview .pump-content .water-tower{
    min-height: 170px;
  }
  .pumpview .pump-content .box-container .box-content > div{
    margin: 0px;
  }
  .pumpview .pump-content .box-container .box-content{
    .water-level-status .level-perc div[plevel="10"]{
      padding-bottom: 0px;
      margin-bottom: -1px;
    }
    .water-level-status .level-perc div[plevel="90"]{
      padding-top: 1px;
    }
  }
  .pumpview .pump-content .box-container .box-header{
    font-size: 12px;
  }
  .pumpview .pump-content .box-container .box-content .water-level-status .level-label{
    font-size: 12px;
    padding-right: 3vh;
  }
  .pumpview .pump-content .box-container[askrepair=true] .box-content{
    height: 126px;
  }
  .pumpview .pump-content .box-container[askanalytics=true] .box-content{
    height: 126px;
  }
  .pumpview .pump-content .box-container[state='Repair'] .box-content{
    height: 126px;
  }
  .pumpview .pump-content .box-container[analytics=true][broken='true'] > .box-content > .pump-state{
    height: 111px;
  }
  .pumpview .pump-content .box-container[repairlevel="2"] > .box-content > .pump-state{
    height: 111px;
  }
}
@media (max-height: 660px){
  .pumpview .pump-header > div{
    margin: 0 8px;
  }
  .pumpview .pump-header .value-tag{
    font-size: 10px !important;
  }
  .pumpview .pump-content .box-container .small-button{
    height: 24px;
    border-radius: 12px;
    line-height: 24px;
    font-size: 9px;
  }
  .pumpview .pump-content .box-container .box-content {
    .water-level-status .level-perc div[plevel="10"]{
      padding-bottom: 0px;
      margin-bottom: -2px;
    }
    .water-level-status .level-perc div[plevel="90"]{
      padding-top: 0px;
    }
    > .left-container > div, > .right-container > div  {
      padding: 7px 20px;
    }
    .water-level-dir{
      width: 16px;
      height: 16px;
    }
    *[state]{
      background-size: 14px 14px;
    }
    > div {
      font-size: 10px;
    }

  }
  .pumpview .pump-content .action-icon{
    width: 22px;
    height: 22px;
    background-size: 12px 12px;
  }
  .pumpview .pump-content .pump-state{
    margin: 8px 0 3px 0 !important;
    .pump-buttons{
      .action-switch{
        width: 64px;
        height: 22px;
        line-height:22px;
        > div{
          font-size: 10px !important;
        }
        .switch-icon{
          top: 2px;
          height: 16px;
          width: 16px;
          left: 4px;
        }
        &[active=true]{
          .switch-icon{
            left: 38px;
          }
        }
      }
    }
  }
  .pumpview .pump-content .water-tower{
    min-height: 155px;
  }
  .pumpview .pump-content .water-pump{
    min-height: 128px;
  }
  .pumpview .pump-content .box-container .repair-message{
    height: 80px;
    font-size: 12px !important;
  }
  .pumpview .pump-content .pump-state .pump-separator{
    height: 4px;
  }
  .pumpview .pump-content .box-container .box-header{
    font-size: 10px;
    span{
      width: 16px;
      height: 16px;
    }
  }
  .pumpview .pump-content .box-container[askrepair=true] .box-content{
    height: 116px;
  }
  .pumpview .pump-content .box-container[askanalytics=true] .box-content{
    height: 116px;
  }
  .pumpview .pump-content .box-container[state='Repair'] .box-content{
    height: 116px;
  }
  .pumpview .pump-content .box-container[analytics=true][broken='true'] > .box-content > .pump-state{
    height: 101px;
  }
  .pumpview .pump-content .box-container[repairlevel="2"] > .box-content > .pump-state{
    height: 101px;
  }
}
@media (max-height: 600px){
  .pumpview .pump-content .water-tower{
    min-height: 145px;
  }
  .pumpview .pump-content .box-container .box-content {
    > .left-container > div, > .right-container > div  {
      padding: 5px 16px;
    }
    .water-level-status .level-perc div[plevel="10"]{
      padding-bottom: 0px;
      margin-bottom: -4px;
    }
    .water-level-status .level-perc div[plevel="90"]{
      padding-top: 0px;
      margin-top: -1px;
    }
    .medium-value{
      font-size: 16px;
    }
    .small-value{
      font-size: 14px;
    }
    .big-value{
      font-size: 16px;
    }
    .water-level-status{
      height: 105px;
    }
  }
}
</style>
